import _ from 'lodash';
import { mapSDKConfigToCustomChartConfig } from '../utils/custom-chart-config-adaptor.util';
export const updateCharVizRefColumnProperties = (chartVizRef, viz) => {
    const updatedColumnProperties = viz.vizProp.columnProperties;
    chartVizRef.current = {
        ...chartVizRef.current,
        vizProp: {
            ...chartVizRef.current.vizProp,
            columnProperties: _.cloneDeep(updatedColumnProperties),
        },
    };
};
export const updateChartVizRefColumns = (chartVizRef, viz) => {
    chartVizRef.current = {
        ...chartVizRef.current,
        columns: _.cloneDeep(viz.columns),
    };
};
export const updateChartVizRefConfig = (chartVizRef, sdkChartConfig) => {
    chartVizRef.current = {
        ...chartVizRef.current,
        config: {
            ...chartVizRef.current.config,
            customChartConfig: mapSDKConfigToCustomChartConfig(sdkChartConfig),
        },
    };
};
//# sourceMappingURL=custom-chart.component.util.js.map